export default "__VITE_ASSET__BV9dX5Ga__"